export const SELECTION_OUTLINE_THICKNESS = 2;

export const APP_CANVAS_ID = "FurnitureConstructorCanvas";
